<template>
  <Fuel :loading="loading" />
</template>
<script>
import Fuel from '@/pages/fuel-card/add'
// import { getFuel } from "@/api/fuel";
export default {
  data() {
    return {
      fuel: null,
      loading: true,
    }
  },
  components: {
    Fuel,
  },
  created() {
    // getFuel.api(this.$route.params.id).then((res) => {
    //     this.fuel = {
    //         ...res,
    //         id: this.$route.params.id,
    //         disabled: this.$route.name.includes("VIEW") ? true : false,
    //     };
    //     this.loading = false;
    // });
  },
}
</script>
